// extracted by mini-css-extract-plugin
export default {"resetButton":"resetButton---b2T2w"};